// Models
import { FormFieldSchema } from 'app/shared/models/form';
import { U21FormFieldTypes } from 'app/shared/u21-ui/components';

// Utils
import { required } from 'app/shared/utils/validation';

// Constants
import { IDENTIFIER_TYPE } from 'app/modules/goAML/schemas/catalogues/identifierType';
import { COUNTRY_CODE_OPTIONS } from 'app/modules/goAML/schemas/catalogues/countryCode';

export const ID_TYPE_FIELD: FormFieldSchema<string> = {
  label: 'ID type',
  name: 'type',
  required: true,
  type: U21FormFieldTypes.SELECT,
  fieldProps: {
    options: IDENTIFIER_TYPE,
  },
  validate: required('ID type is required.'),
};

export const NUMBER_FIELD: FormFieldSchema<string> = {
  label: 'Number',
  name: 'number',
  required: true,
  type: U21FormFieldTypes.TEXT,
  validate: required('Number is required.'),
};

export const ISSUE_COUNTRY_FIELD: FormFieldSchema<string> = {
  label: 'Issue country',
  name: 'issue_country',
  type: U21FormFieldTypes.SELECT,
  fieldProps: {
    options: COUNTRY_CODE_OPTIONS,
  },
  required: true,
  validate: required('Issue country is required.'),
};

export const ISSUE_DATE: FormFieldSchema<string> = {
  label: 'Issue date',
  name: 'issue_date',
  type: U21FormFieldTypes.DATE_PICKER,
};

export const EXPIRY_DATE: FormFieldSchema<string> = {
  label: 'Expiry date',
  name: 'expiry_date',
  type: U21FormFieldTypes.DATE_PICKER,
};

export const ISSUED_BY_FIELD: FormFieldSchema<string> = {
  label: 'Issued by',
  name: 'issued_by',
  type: U21FormFieldTypes.SELECT,
  fieldProps: {
    options: COUNTRY_CODE_OPTIONS,
  },
};

export const COMMENTS_DATE: FormFieldSchema<string> = {
  label: 'Comments',
  name: 'comments',
  type: U21FormFieldTypes.TEXTAREA,
};

export const T_PERSON_IDENTIFICATION_SCHEMA = [
  ID_TYPE_FIELD,
  NUMBER_FIELD,
  ISSUE_COUNTRY_FIELD,
  ISSUE_DATE,
  EXPIRY_DATE,
  ISSUED_BY_FIELD,
  COMMENTS_DATE,
];
